import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import NavbarWrapper from 'contexts/NavbarWrapper';
import Assistant from 'pages/Assistant';
import CrewManagement from 'pages/CrewManagement';
import CrewMemberDetails from 'pages/CrewMemberDetails';
import CrewTimeline from 'pages/CrewTimeline';
import ErrorPage from 'pages/Error';
import Profile from 'pages/Profile';
import RideDetails from 'pages/RideDetails';
import RideListPage from 'pages/RideListPage';
import { WorkAssignmentsList } from 'pages/WorkAssignments';

const router = createBrowserRouter([
	{
		path: '/',
		element: <NavbarWrapper />,
		children: [
			{
				path: '/',
				element: <RideListPage />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/details/:rideId',
				element: <RideDetails />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/work-assignments',
				element: <WorkAssignmentsList />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/crew-management',
				element: <CrewManagement />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/crew-management/:crewId',
				element: <CrewMemberDetails />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/crew-timeline',
				element: <CrewTimeline />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/profile',
				element: <Profile />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/assistant',
				element: <Assistant />,
				errorElement: <ErrorPage />,
			},
			{
				path: '/*',
				element: <ErrorPage />,
				errorElement: <ErrorPage />,
			},
		],
	},
]);

export default function AppRouter() {
	return <RouterProvider router={router} />;
}
